import { buildDropdown } from '../../utils/Shipment';
import { shipmentFormDropdowns } from '../../graphQL/queries/shipmentQueries';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _has from 'lodash/has';

import {
  CUSTOM_FIELD_VISIBILITY_VALUE,
  CUSTOM_FIELD_HIDDEN_VALUE
} from '../../constants/constants';

export const getLocationContactDropdowns = async (ApolloClient, orgId) => {
  try {
    const {
      data: {
        contact: { all: allContacts },
        location: { all: allLocations }
      }
    } = await ApolloClient.query({
      query: shipmentFormDropdowns,
      variables: { orgId }
    });
    const contacts = allContacts.map(contact => {
      return {
        value: contact.id,
        title: `${contact.firstName} ${contact.lastName}`,
        data: contact
      };
    });
    const locations = buildDropdown(allLocations, 'name', 'id');
    return Promise.resolve({ locations, contacts });
  } catch (error) {
    return Promise.reject(error);
  }
};
export const getLocationById = (locationId, locations) => {
  const selectedLocation = locations.find(location => {
    return location.value === String(locationId);
  });
  if (selectedLocation) {
    return selectedLocation.data;
  }
  return null;
};
export const formatBillToInfo = (billToInfo, stop) => {
  return {
    ...billToInfo,
    companyName: _get(stop, 'locationAddress.locationName'),
    billToAddress: {
      address1: _get(stop, 'locationAddress.address1', null),
      address2: _get(stop, 'locationAddress.address2', null),
      city: _get(stop, 'locationAddress.city', null),
      state: !stop ? null : _isEmpty(stop.locationAddress.state)
        ? null
        : _get(stop, 'locationAddress.state', null),
      postalCode: _get(stop, 'locationAddress.postalCode', null),
      country: _isEmpty(stop.locationAddress.country)
        ? null
        : _get(stop, 'locationAddress.country', null)
    },
    billToContactInfo: {
      firstName: _get(stop, 'contactInfo.firstName', null),
      lastName: _get(stop, 'contactInfo.lastName', null),
      email: _get(stop, 'contactInfo.email', null),
      phone: _get(stop, 'contactInfo.phone', null)
    }
  };
};
export const buildReferenceField = (field, values) => {
  const fieldObject = { ...field };
  fieldObject.value = {
    values,
    stringId: field.stringId,
    maxResponses: field.maxResponses,
    required: field.customFieldRequirementLevelId === 'ERROR' ? true : false
  };
  return fieldObject;
};
export const populateReferenceFields = (referenceFields, values) => {
  const allReferenceFields = {
    viewable: [],
    available: [],
    formValues: []
  };
  if (values.length === 0) {
    referenceFields.forEach(field => {
      if (field.customFieldVisibilityId === CUSTOM_FIELD_VISIBILITY_VALUE) {
        allReferenceFields.viewable.push(buildReferenceField(field, []));
      }

      if (field.customFieldVisibilityId === CUSTOM_FIELD_HIDDEN_VALUE) {
        allReferenceFields.available.push(buildReferenceField(field, []));
      }
    });
  } else {
    //we have data saved
    const valuesObject = {};
    values.forEach(value => {
      valuesObject[value.stringId] = value.values;
    });

    referenceFields.forEach(field => {
      const fieldIdentifier = field.stringId;
      if (field.customFieldVisibilityId === CUSTOM_FIELD_VISIBILITY_VALUE) {
        allReferenceFields.viewable.push(
          buildReferenceField(field, valuesObject[fieldIdentifier])
        );
      }

      if (field.customFieldVisibilityId === CUSTOM_FIELD_HIDDEN_VALUE) {
        if (_has(valuesObject, fieldIdentifier)) {
          allReferenceFields.viewable.push(
            buildReferenceField(field, valuesObject[fieldIdentifier])
          );
        } else {
          allReferenceFields.available.push(buildReferenceField(field, []));
        }
      }
    });
  }
  allReferenceFields.viewable.forEach(field => {
    allReferenceFields.formValues.push(field.value);
  });
  return allReferenceFields;
};
